import e from "./index892.js";
var o = Object.prototype, c = o.hasOwnProperty, f = o.toString, r = e ? e.toStringTag : void 0;
function p(t) {
  var a = c.call(t, r), n = t[r];
  try {
    t[r] = void 0;
    var i = !0;
  } catch {
  }
  var g = f.call(t);
  return i && (a ? t[r] = n : delete t[r]), g;
}
export {
  p as default
};
